import styled from 'styled-components';

export const StyledLabel = styled.label(
  ({ error, theme: { font, colors, spacing } }) => ({
    alignItems: 'center',
    color: error ? colors.error : colors.darkGrey,
    display: 'flex',
    flexDirection: 'row',
    fontSize: font.size.xs,
    fontWeight: font.weight.bold,
    justifyContent: 'flex-start',
    lineHeight: font.lineHeight.xs,
    paddingBottom: spacing.xs,
    width: '100%',
  }),
);

export const StyledRequiredAsterix = styled.span(
  ({ theme: { spacing, font, colors } }) => ({
    color: colors.error,
    fontSize: font.size.xxs,
    paddingLeft: spacing.xxs,
    verticalAlign: 'super',
  }),
);
